import useSubtitles from "@/components/course/lesson/hooks/useSubtitles";
import { forwardRef, useEffect } from "react";

export const NativeVideoPlayer = forwardRef(
    ({ videoUrl, subtitleUrl: _subtitleUrl, autoplay, onProgress }, ref) => {
        useEffect(() => {
            const player = ref?.current;
            if (player) {
                if (!autoplay) player?.pause();
                if (autoplay) player?.play();
            }
        }, [autoplay]);

        const { subtitleUrl, getSubtitleUrl } = useSubtitles();

        useEffect(() => {
            getSubtitleUrl(_subtitleUrl);
        }, [_subtitleUrl]);

        if (!videoUrl) {
            return <></>;
        }

        return (
            <video
                controls
                ref={ref}
                width="100%"
                preload="metadata"
                autoPlay={!!autoplay}
                id="native-video-player"
                onProgress={(e) => {
                    if (typeof onProgress == "function") {
                        let video = e.target;
                        let duration = video?.duration;
                        let currentTime = video?.currentTime;
                        onProgress(duration, currentTime);
                    }
                }}
            >
                <source src={videoUrl} type="video/mp4" />
                {_subtitleUrl && subtitleUrl && (
                    <track
                        src={subtitleUrl}
                        kind="captions"
                        srcLang="fa"
                        label="فارسی"
                    />
                )}
                <p>
                    Your browser does not support HTML video. Here is a
                    <a href={videoUrl} download={videoUrl}>
                        link to the video
                    </a>{" "}
                    instead.
                </p>
            </video>
        );
    }
);
